import { render, staticRenderFns } from "./WFieldCheckbox.vue?vue&type=template&id=7623adbc&"
import script from "./WFieldCheckbox.vue?vue&type=script&lang=ts&"
export * from "./WFieldCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports